var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multi-selector',{attrs:{"filterable":false,"options":_vm.contactStatusList,"remote":_vm.selfStatusSearch},model:{value:(_vm.contact),callback:function ($$v) {_vm.contact=$$v},expression:"contact"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56219d36","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bussiness-select/ContactStatusSelector.vue
// module id = null
// module chunks = 